import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withXhr,
  withInterceptors,
} from '@angular/common/http';
import { API_CONFIG, TULL_API_CONFIG } from './core/api-conf';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { NotificationDispatcherService } from './infrastructure/ui/notifications/notification-dispatcher.service';
import { IDENTITY_SIGNAL } from './core/auth/identity.token';
import { ProfileService } from './core/profile.service';
import { provideNativeDateAdapter } from '@hypergraph/tapestry';
import { lastValueFrom } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptors([
        (req, next) => {
          const apiReq = req.clone({
            withCredentials: true,
          });
          return next(apiReq);
        },
      ]),
    ),
    provideNativeDateAdapter(),
    importProvidersFrom(MatFormFieldModule),
    { provide: API_CONFIG, useValue: TULL_API_CONFIG },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      },
    },
    provideAppInitializer(() => {
      inject(NotificationDispatcherService);
      const ps = inject(ProfileService);
      return lastValueFrom(ps.loadProfile()).catch(() => {
        console.log('failed');
      });
    }),
    {
      provide: IDENTITY_SIGNAL,
      useFactory: (auth: ProfileService) => auth.identity,
      deps: [ProfileService],
    },
  ],
};
